/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动id
   */
  event_id: string;
}
/**
 * 资源列表
 */
export type ResourceList = {
  /**
   * 会员名字，如个人免费版
   */
  member_type_name: string;
  /**
   * 包含的所有能力
   */
  data_list: {
    /**
     * 方数
     */
    audience_number: number;
    /**
     * 外场直播席
     */
    live_audience_number: number;
    /**
     * 日常时间限制（秒），-1表示永久
     */
    duration_limit: number;
    /**
     * 会场类型
     */
    venue_type: number;
  }[];
}[];
export interface DashboardCommonGetResourceDataRes {
  nonce: string;
  code: number;
  msg: string;
  data: Data;
}
export interface Data {
  resource_list: ResourceList;
  /**
   * 会员结束时间（秒）,-1表示没有会员
   */
  member_expire_time: number;
}

const DashboardCommonGetResourceData = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardCommonGetResourceDataRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/common/get-resource-data',
    data,
    ctx,
  );

  return res;
};

export default DashboardCommonGetResourceData;
